import { Routes } from "@angular/router";
import { AppPage, AuthGuardService } from "jk-service";

import { Jckpi37Component } from './jckpi37/jckpi37.component';
import { Jckpi38Component } from './jckpi38/jckpi38.component';
import { JCKPQ03Component } from './jckpq03/jckpq03.component';

export const jckPages: AppPage[] = [
  {
    title: '占卦記錄',
    url: '/jck/jckpi37',
    id: 'jckpi37',
    icon: '',
    isCheckPower: true,
  },
  {
    title: '占卦',
    url: '/jck/jckpi38',
    id: 'jckpi38',
    icon: '',
    isCheckPower: false,
  },
  {
    title: 'API LOG查詢',
    url: '/jck/jckpq03',
    id: 'jckpq03',
    icon: '',
    isCheckPower: true,
  },
  {
    title: '網址建立作業',
    url: '/jck/jckpi39',
    id: 'jckpi39',
    icon: '',
    isCheckPower: true,
  },

];

export const jckRoutes: Routes = [
  {
    path: 'jckpi37',
    component: Jckpi37Component,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'jckpi38',
    component: Jckpi38Component,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'jckpq03',
    component: JCKPQ03Component,
    canActivate: [ AuthGuardService ]
  },
  ];
